import Cookies from 'js-cookie'
// import secret from '@/utils/secret'

const REDIRECT_URL_KEY = 'REDIRECT_URL_KEY'
const PLATFORM_URL_KEY = 'PLATFORM_URL_KEY'
const CONSUMER_IDENTITY_KEY = 'us-key'
const CONSUMER_CONDITION_KEY = 'us-key'
const DO_MAIN = 'cabplink.com'
const ORGANISED_MARK = 'organised_mark'
//详情页目录进入阅读器自带id
const FROM_CATALOGID = 'from_catalogid'


/** 设置token */
export function getToken () {
  return Cookies.get(CONSUMER_CONDITION_KEY)
}
export function setToken (token, expiresVal) {
  return expiresVal ? Cookies.set(CONSUMER_CONDITION_KEY, token, {expires: 7, domain: DO_MAIN}) : Cookies.set(CONSUMER_CONDITION_KEY, token, {domain: DO_MAIN})
}
export function removeToken () {
  return Cookies.remove(CONSUMER_IDENTITY_KEY, {domain: DO_MAIN})
}

/** 登录状态 */
export function getConsumerCondition () {
  return Cookies.get(CONSUMER_CONDITION_KEY)
}
export function setConsumerCondition (token) {
  return Cookies.set(CONSUMER_CONDITION_KEY, token, {domain: DO_MAIN})
}
export function removeConsumerCondition () {
  return Cookies.remove(CONSUMER_CONDITION_KEY, {domain: DO_MAIN})
}

/** 回调路径 */
export function setRedirectUrl (content) {
  Cookies.set(REDIRECT_URL_KEY, content)
}
export function getRedirectUrl () {
  return Cookies.get(REDIRECT_URL_KEY)
}
export function removeRedirectUrl () {
  Cookies.remove(REDIRECT_URL_KEY)
}

/** 平台路径 */
export function setPlatformUrl (content) {
  Cookies.set(PLATFORM_URL_KEY, content)
}
export function getPlatformUrl () {
  return Cookies.get(PLATFORM_URL_KEY)
}
export function removePlatformUrl () {
  Cookies.remove(PLATFORM_URL_KEY)
}

/** 机构标识 */
export function setOrganisedMark () {
  Cookies.set(ORGANISED_MARK, 'organised', {domain: DO_MAIN})
}
export function getOrganisedMark () {
  return Cookies.get(ORGANISED_MARK)
}
export function removeOrganisedMark () {
  return Cookies.remove(ORGANISED_MARK, {domain: DO_MAIN})
}

/** 设置消费者状态信息 */
export function setUserToken (content) {
  Cookies.set(CONSUMER_CONDITION_KEY, content, {domain: DO_MAIN})
}
export function getUserToken () {
  return Cookies.get(CONSUMER_CONDITION_KEY)
}
export function removeUserToken () {
  Cookies.remove(CONSUMER_CONDITION_KEY, {domain: DO_MAIN})
}
export function removeB () {
  return Cookies.remove(CONSUMER_CONDITION_KEY,{domain: DO_MAIN})
}
/** 来自详情页目录 */
export function getFromCatalogid () {
  return Cookies.get(FROM_CATALOGID)
}
export function setFromCatalogid (id) {
  return Cookies.set(FROM_CATALOGID, id, {expires: 7, domain: DO_MAIN})
}
export function removeFromCatalogid () {
  return Cookies.remove(FROM_CATALOGID, {domain: DO_MAIN})
}


// WEBPACK FOOTER //
// ./src/utils/cookies.js